"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // @ts-nocheck

var v4_1 = __importDefault(require("uuid/v4"));

function initialState() {
  return {
    class: "disbursement",
    type: null,
    receivedAt: null,
    // non-employment
    value: 0,
    // employment
    valueIncome: 0,
    valueCommission: 0,
    valueOvertime: 0,
    deductions: {
      // Taxes
      federalTaxes: 0,
      stateTaxes: 0,
      otherTaxes: 0,
      medicare: 0,
      socialSecurity: 0,
      // Insurance
      medicalInsurance: 0,
      dentalInsurance: 0,
      visionInsurance: 0,
      lifeInsurance: 0,
      // Other Obligations
      mandatoryObligations: 0,
      voluntaryObligations: 0,
      loanObligations: 0,
      unionObligations: 0,
      hsaObligations: 0,
      domesticObligations: 0,
      // Other
      others: [] // [deduction]

    },
    additionalDescription: null,
    // gross
    year: null // files: [], // Reference?

  };
}

var createDisbursement = function createDisbursement(attrs) {
  return _objectSpread(_objectSpread(_objectSpread({}, initialState()), attrs), {}, {
    deductions: _objectSpread(_objectSpread({}, initialState().deductions), attrs.deductions),
    id: (0, v4_1.default)()
  });
};

exports.default = createDisbursement;